module.exports = __webpack_public_path__ + "static/media/PDF_130.d8dfd3ca.pdf";